import { render, staticRenderFns } from "./skills-card-form-message-send.vue?vue&type=template&id=543aa660&"
import script from "./skills-card-form-message-send.vue?vue&type=script&lang=js&"
export * from "./skills-card-form-message-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports